module.exports = "<div class=\"page\">\r\n    <div class=\"page-content container-fluid\" >\r\n        <flash-messages></flash-messages>\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/layouts/basic.template.html
// module id = ../../../../../src/app/layout/layouts/basic.template.html
// module chunks = main